"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.text = exports.emphasisOptions = exports.default = exports.asOptions = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _intents = require("@ux/intents");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
// Possible options for as prop
const asOptions = exports.asOptions = ['title', 'heading', 'paragraph', 'action', 'input', 'label', 'caption'];
const emphasisOptions = exports.emphasisOptions = Object.values(_intents.feedbackExpressions).map(v => v.toLowerCase());
const UX_TEXT_CLASSNAME = 'ux-text';

/**
 * Creates a function which represents a dynamic React component
 *
 * @param {import('@ux/text').HTMLTagList} TagName - The tag name of the element to use for text
 * @returns {import('@ux/text').TextComponent<TagName>} - A function to create a component
 */
function create(TagName) {
  /**
   * Creates a React component using the given tag name
   *
   * @type {import('@ux/text').TextComponent<TagName>}
   */
  const Text = /*#__PURE__*/(0, _react.forwardRef)(function Text({
    as,
    className,
    children,
    emphasis,
    size,
    text,
    ...rest
  }, ref) {
    return /*#__PURE__*/_react.default.createElement(TagName, (0, _extends2.default)({
      ref: ref,
      "data-version": "2500",
      className: (0, _classnames.default)(UX_TEXT_CLASSNAME, className, {
        [`${UX_TEXT_CLASSNAME}-size${size}`]: typeof size === 'number' && size >= -2 && size < 6,
        [`${UX_TEXT_CLASSNAME}-${as}`]: as && asOptions.includes(as),
        [`${UX_TEXT_CLASSNAME}-feedback-${emphasis}`]: emphasis && emphasisOptions.includes(emphasis)
      })
    }, rest), children ?? text);
  });

  /**
   *
   * @enum {Object} expected types of properties.
   * @public
   */
  Text.propTypes = {
    /** The type of text expected in the component */
    as: _propTypes.default.oneOf(asOptions),
    /** Text to be displayed */
    children: _propTypes.default.node,
    /** Classes to apply to component */
    className: _propTypes.default.string,
    /** The emphasis of text expected in the component */
    emphasis: _propTypes.default.oneOf(emphasisOptions),
    /** The size of the text, affected by the 'as' prop */
    size: _propTypes.default.number,
    /** Text to be displayed */
    text: _propTypes.default.node
  };
  return Text;
}

/**
 * @type {import('@ux/text').HTMLPropProxy<import('@ux/text').TextProps>}
 */
const text = exports.text = new Proxy(() => {}, {
  get: function get(target, prop) {
    // Deliberately not using hasOwnProperty to catch things like __proto__
    if (!String(prop).startsWith('_') && typeof target[prop] === 'undefined') {
      // Cache access by creating a key with value
      const component = create(prop);

      // Setting a display name helps tools represent it accurately in JSX strings and aids debugging.
      // For example, instead of <Text />, it will be '<text.span />'
      if (typeof prop === 'string') component.displayName = `text.${prop}`;
      target[prop] = component;
    }
    // Always return thing at that key, either undefined or thing set
    return Reflect.get(...arguments);
  }
});
var _default = exports.default = text;